<template>
  <div class="layout-body">
    <!-- 顶部导航 -->
    <div class="layout-header">
      <div class="header-left">
        <span class="header-logo">新能源精细化功率预测平台</span>
        <span class="header-time">{{ currentTime }}</span>
      </div>
      <div class="header-right">
        <router-link to="/wind" class="header-tab" active-class="tab-active">风电</router-link>
        <router-link to="/solar" class="header-tab" active-class="tab-active">光伏</router-link>
      </div>
    </div>

    <!-- 页面内容 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  data() {
    return {
      currentTime: ''
    }
  },
  mounted() {
    this.updateTime()
    setInterval(() => {
      this.updateTime()
    }, 1000)
  },
  methods: {
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekDay}`
    }
  }
}
</script>

<style scoped>
.layout-body {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(135deg, #080f1f 0%, #0d1a33 50%, #080f1f 100%);
}

.layout-header {
  height: 72px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  flex-shrink: 0;
  position: relative;
  z-index: 1000;
}

.layout-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 5%;
  width: 90%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 216, 255, 0.3), rgba(0, 216, 255, 0.6), rgba(0, 216, 255, 0.3), transparent);
}

.header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.header-logo {
  font-size: 22px;
  font-weight: 800;
  background: linear-gradient(90deg, #00d8ff, #4dc9f6, #00d8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 6px;
  white-space: nowrap;
}

.header-time {
  font-size: 12px;
  color: rgba(0, 216, 255, 0.5);
  letter-spacing: 2px;
  white-space: nowrap;
  padding-left: 2px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-tab {
  padding: 8px 28px;
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(0, 216, 255, 0.04);
  white-space: nowrap;
  border: 1px solid rgba(0, 216, 255, 0.15);
  border-radius: 6px;
  letter-spacing: 2px;
  position: relative;
}

.header-tab:hover {
  color: #00d8ff;
  background: rgba(0, 216, 255, 0.08);
  border-color: rgba(0, 216, 255, 0.4);
  box-shadow: 0 0 20px rgba(0, 216, 255, 0.1);
}

.header-tab.tab-active {
  color: #fff;
  background: linear-gradient(135deg, rgba(0, 216, 255, 0.25), rgba(0, 180, 220, 0.15));
  border-color: #00d8ff;
  box-shadow: 0 0 24px rgba(0, 216, 255, 0.2), inset 0 0 12px rgba(0, 216, 255, 0.05);
}
</style>
